/* eslint-disable no-param-reassign */
import type { AutocompleteSkill } from 'src/components/skillAutocomplete/types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { GetUserCreatedQuestionResponse } from 'src/openapi';
import {
  getCreatedQuestions,
  getQuestionCreationMilestone,
} from '../actions/contribute';
import type { ContributeState } from '../types/contribute';

const initialState: ContributeState = {
  createdQuestions: null,
  isFetchingQuestions: false,
};

const contributeSlice = createSlice({
  name: 'contribute',
  initialState,
  reducers: {
    setSelectedContributeSkill: (
      state,
      action: PayloadAction<AutocompleteSkill>,
    ) => {
      state.selectedContributeSkill = action.payload;
    },
    setCreatedQuestions: (
      state,
      action: PayloadAction<GetUserCreatedQuestionResponse>,
    ) => {
      state.createdQuestions = action.payload;
    },
    resetQuestionsList: (state) => {
      state.createdQuestions = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCreatedQuestions.pending, (state) => {
      state.isFetchingQuestions = true;
    });
    builder.addCase(getCreatedQuestions.rejected, (state) => {
      state.isFetchingQuestions = false;
    });
    builder.addCase(getCreatedQuestions.fulfilled, (state, action) => {
      state.createdQuestions = action.payload;
      state.isFetchingQuestions = false;
    });
    builder.addCase(getQuestionCreationMilestone.fulfilled, (state, action) => {
      state.questionCreationMilestone = action.payload;
    });
  },
});

export const {
  setSelectedContributeSkill,
  resetQuestionsList,
  setCreatedQuestions,
} = contributeSlice.actions;

export default contributeSlice.reducer;
